/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formmessage_Placeholder1Inputs */

const ja_contact_formmessage_placeholder1 = /** @type {(inputs: Contact_Formmessage_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ内容を入力してください`)
};

const en_contact_formmessage_placeholder1 = /** @type {(inputs: Contact_Formmessage_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`...`)
};

/**
* | output |
* | --- |
* | "..." |
*
* @param {Contact_Formmessage_Placeholder1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formmessage_placeholder1 = /** @type {((inputs?: Contact_Formmessage_Placeholder1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formmessage_Placeholder1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formmessage_placeholder1(inputs)
	return en_contact_formmessage_placeholder1(inputs)
});
export { contact_formmessage_placeholder1 as "contact_formMessage_placeholder" }